import { Component } from '@angular/core';

@Component({
    selector: 'app-redirect-information',
    template: '<app-generic-spinner data-testid="loading-spinner"></app-generic-spinner>',
    styles: `
  :host {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
  }
  `,
    standalone: false
})
export class RedirectInformationComponent {}
